import { environment } from "../../environment/environment"
import { EventSerializer } from "../event/serializer"
import { NewsSerializer } from "../news/serializer"
import { Resource } from "../resource"
import { Banner, CampaignBanner, GenericBanner } from "./banner"



export class BannerSerializer extends Resource {
    fromJson(json: any) {
        const banner = new Banner()
        if (json.link_type === "event") {
            const eventSerializer = new EventSerializer()
            banner.event = eventSerializer.fromJson(json.event)
        } else {
            const newsSerializer = new NewsSerializer()
            banner.news = newsSerializer.fromJson(json.news)
        }
        banner.linkType = json.link_type
        banner.title = json.title
        if (json.image) {
            banner.image = `${environment.basePath}/${environment.imagesPath}/banners/${json.image}.jpg` 
        } else  {
            banner.image = null
        }
        return banner
    }
    toJson(item: Banner) {
        return {
        }
    }
}
export class GenericBannerSerializer extends Resource {
    fromJson(json: any) {
        const banner = new GenericBanner()
        banner.text = json.text
        banner.content = json.content
        banner.link = json.link
        if (json.filename) {
            banner.image = `${environment.basePath}/assets/generic_banners/${json.filename}.jpg` 
        } 
        if (json.filename_mobile) {
            banner.imageMobile = `${environment.basePath}/assets/generic_banners/${json.filename_mobile}.jpg` 
        } 
        return banner
    }
    toJson(item: any) {
        return {
        }
    }
}
export class CampaignBannerSerializer extends Resource {
    fromJson(json: any) {
        const banner = new CampaignBanner()
        banner.link = json.link
        if (json.filename) {
            banner.image = `${environment.basePath}/assets/main_page_banners/${json.filename}.jpg` 
        } 
        if (json.filename_mobile) {
            banner.imageMobile = `${environment.basePath}/assets/main_page_banners/${json.filename_mobile}.jpg` 
        } 
        return banner
    }
    toJson(item: any) {
        return {
        }
    }
}
